module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header', [_c('cp-nav')], 1), _vm._v(" "), _c('section', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), (_vm.horaInicio) ? _c('div', [_c('p', [_vm._v("Hora de Início:")]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.horaInicio))]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": "/cp/chegadas"
    }
  }, [_vm._v("Chegadas")])], 1) : _vm._e(), _vm._v(" "), (!_vm.horaInicio) ? _c('div', [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.inicia
    }
  }, [_vm._v("Inicia")])]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header"
  }, [_c('h2', [_vm._v("Início da Prova")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10a85086"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/cp/Inicio.vue
// module id = 245
// module chunks = 1